import _ from 'lodash';
import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';
import MathUtil from './MathUtil';
import IndexReferenceType from 'src/models/IndexReferenceType';
import { LandSystem } from 'src/models/LandSystem';
import Ownership from 'src/models/tract_detail/Ownership';
import { convertInstrumentTypesToSelectList } from 'src/models/InstrumentType';
import IOwner from 'src/models/IOwner';
import { Tag } from 'react-tag-autocomplete';

export default class AgreementUtil {
    // tslint:disable-next-line: no-any
    public static mapSelectedOwnerTractData(ownerData: any, tractData: LeaseGenerationOwnerData) {
        const ownerDataObj = JSON.parse(ownerData);
        console.log('from agr util', ownerDataObj);
        return 1;
    }

    public static findLeaseTractChanges(ownerTracts: ContractGenerationTractDetail[], leaseTracts: ContractGenerationTractDetail[], landSystem: LandSystem): boolean {
        if (ownerTracts.length !== leaseTracts.length) {
            return true;
        }

        let ownerTemps = ownerTracts.map(ot => {
            ot.grossAcres = ot.grossAcres > 0 ? ot.grossAcres : 0;
            ot.decimalInterest = ot.decimalInterest > 0 ? ot.decimalInterest : 0;

            return {
                section: ot.section > 0 ? ot.section.toString() : '0',
                township: landSystem === LandSystem.Eastern ? (ot.easternTownship?.length > 0 ? ot.easternTownship : '') : (ot.township?.length > 0 ? ot.township : ''),
                range: (!!ot.range && ot.range?.length > 0 && ot.range !== '0') ? ot.range : null,
                tractName: ot.tractName?.length > 0 ? ot.tractName : '',
                grossAcres: ot.grossAcres,
                legalDescription: ot.legalDescription?.length > 0 ? ot.legalDescription : '',
                decimalInterest: ot.decimalInterest,
                hasNEMI: ot.hasNEMI,
                ownershipId: ot.ownershipId,
                county: ot.county,
                shortLegalDescription: ot.shortLegalDescription ? ot.shortLegalDescription : '',
                leasedStatus: ot.leasedStatus ? ot.leasedStatus : ''
            };
        });

        for (let lt of leaseTracts) {
            lt.grossAcres = lt.grossAcres > 0 ? lt.grossAcres : 0;
            lt.decimalInterest = lt.decimalInterest > 0 ? lt.decimalInterest : 0;

            let leaseTemp = {
                section: lt.section > 0 ? lt.section.toString() : '0',
                township: ((lt.township?.length > 0 && lt.township !== ' ' && lt.township !== '0') ? lt.township :
                    ((lt.easternTownship?.length > 0 && lt.easternTownship !== ' ' && lt.easternTownship !== '0' ? lt.easternTownship : ''))),
                range: (!!lt.range && lt.range?.length > 0 && lt.range !== '0') ? lt.range : null,
                tractName: lt.tractName?.length > 0 ? lt.tractName : '',
                grossAcres: lt.grossAcres,
                legalDescription: lt.legalDescription?.length > 0 ? lt.legalDescription : '',
                decimalInterest: lt.decimalInterest,
                hasNEMI: lt.hasNEMI,
                ownershipId: lt.ownershipId,
                county: lt.county,
                shortLegalDescription: lt.shortLegalDescription ? lt.shortLegalDescription : '',
                leasedStatus: lt.leasedStatus ? lt.leasedStatus : ''
            };

            let ownerTract = ownerTemps.find(ot => ot.ownershipId === leaseTemp.ownershipId);
            if (ownerTract === undefined) {
                return true;
            }

            if (!_.isEqual(ownerTract, leaseTemp)) {
                return true;
            }
        }

        return false;
    }

    // Returns Total Acreages for Generated Contract: [TotalGross, TotalNet]
    public static calcTotalAcreages = (tractList: Array<ContractGenerationTractDetail>, landSystem: LandSystem): number[] => {
        let tempTotalGrossAcres = 0;
        let tempTotalNetAcres = 0;

        let clickedTracts: Array<ContractGenerationTractDetail> = tractList?.filter((t: ContractGenerationTractDetail) => t.includeTract === true);
        let duplicates: Array<ContractGenerationTractDetail> = [];

        for (const t of clickedTracts) {
            let tNumber = t.surfaceTractNumber > 0 ? t.surfaceTractNumber : t.tractNumber;

            let duplicateExist: ContractGenerationTractDetail = duplicates.find(
                (d) => {
                    let dtNumber = d.surfaceTractNumber > 0 ? d.surfaceTractNumber : d.tractNumber;
                    if (landSystem === LandSystem.EastTexas) {
                        return dtNumber === tNumber;
                    }
                    return `${d.sectionNumber}.${dtNumber}` === `${t.sectionNumber}.${tNumber}`;
                }
            );

            let currentNet = parseFloat(t.decimalInterest + '') * parseFloat(t.grossAcres + '') || 0;

            if (!duplicateExist && !!t.includeTract) {
                // ONLY ADD GROSS IF NOT PART OF THE SAME TRACT. (DON'T DOUBLE UP WITH HORIZONS OR EXTRA OWNERSHIPS.)
                tempTotalGrossAcres += parseFloat(t.grossAcres + '') || 0;
                tempTotalNetAcres += currentNet;
                t.netAcres = currentNet;
                duplicates.push(t);
            } else if (duplicateExist.horizonNumber === t.horizonNumber) {
                // AGGREGATE NET ACRES FOR OWNERSHIPS ON THE SAME HORIZON.
                tempTotalNetAcres += currentNet;
            } else if (duplicateExist.netAcres < currentNet) {
                // SUBTRACT SMALLER NET ACREAGE IF OWNERSHIPS EXIST ACROSS MULTIPLE HORIZONS ON THE SAME TRACT.
                tempTotalNetAcres += currentNet - duplicateExist.netAcres;
            }
        }

        return [tempTotalGrossAcres, tempTotalNetAcres];
    };

    // NOTE: This has updated to the RTE box. It will no longer update the plain text Legal Description
    public static formatTractListLegal = (tractList: Array<ContractGenerationTractDetail>): string => {
        let tractNumber = 1;
        let newLegal = '';

        let clickedTracts: Array<ContractGenerationTractDetail> = tractList?.filter((t: ContractGenerationTractDetail) => t.includeTract === true);
        let filteredTracts: Array<ContractGenerationTractDetail> = AgreementUtil.tractListData(clickedTracts);

        if (filteredTracts.length === clickedTracts.length) {
            for (let ft of filteredTracts) {
                if (!!ft.includeTract) {
                    newLegal += `<p>TRACT ${tractNumber ? tractNumber : ''}: ${ft.legalDescription ? ft.legalDescription : ''} </p>`;
                    tractNumber++;
                }
            }
        } else if (filteredTracts.length !== clickedTracts.length) {
            let completeTracts: Array<ContractGenerationTractDetail> = AgreementUtil.tractListData(tractList);
            let duplicates: Array<ContractGenerationTractDetail> = [];
            for (const t of clickedTracts) {
                let inCT: ContractGenerationTractDetail = completeTracts.find(
                    (c) => `${c.sectionNumber}.${c.tractNumber}.${c.horizonNumber}` === `${t.sectionNumber}.${t.tractNumber}.${t.horizonNumber}`
                );
                let duplicateExist: ContractGenerationTractDetail = duplicates.find(
                    (d) => `${d.sectionNumber}.${d.tractNumber}.${d.horizonNumber}` === `${t.sectionNumber}.${t.tractNumber}.${t.horizonNumber}`
                );

                if (!!inCT && !duplicateExist && !!t.includeTract) {
                    newLegal += `<p>TRACT ${tractNumber ? tractNumber : ''}: ${t.legalDescription ? t.legalDescription : ''} </p>`;
                    tractNumber++;
                    duplicates.push(t);
                }

                if (!!inCT && !!duplicateExist && !!t.includeTract) {
                    newLegal += `<p>TRACT ${tractNumber ? tractNumber : ''}: ${t.legalDescription ? t.legalDescription : ''} </p>`;
                    tractNumber++;
                }

                if (!inCT && !duplicateExist && !!t.includeTract) {
                    newLegal += `<p>TRACT ${tractNumber ? tractNumber : ''}: ${t.legalDescription ? t.legalDescription : ''} </p>`;
                    tractNumber++;
                }
            }
        }

        return newLegal;
    };

    public static formatShortLegalDescription = (tractList: Array<ContractGenerationTractDetail>, ownershipList: Array<Ownership>, ownerInfoDetails: IOwner): string => {
        if (!tractList || tractList.length === 0) {
            return '';
        }

        var filteredTractList = tractList.filter(t => t.includeTract === true && t.shortLegalDescription && t.shortLegalDescription.trim().length > 0);
        var filteredOwnershipList = ownershipList.filter(o => filteredTractList.some(t => Number(t.ownershipId) === o.id));

        filteredTractList.forEach((tract: ContractGenerationTractDetail) => {
            var owner = filteredOwnershipList.find(o => o.id === Number(tract.ownershipId));
            var ownerInfo = owner.ownerLookUpId === ownerInfoDetails.ownerLookUpId ? ownerInfoDetails : undefined;

            // if there is vesting deed data, replace the tract's short legal description with a modified one
            if (owner.vestingDeedDate && owner.vestingDeedReference && owner.vestingDeedInstrumentType) {
                let newShortLegalDescription = AgreementUtil.regenerateShortLegalDescription(tract, owner, ownerInfo);
                console.log(newShortLegalDescription);
                tract.shortLegalDescription = newShortLegalDescription;
            }
        });

        // Take all shortLegalDescription values, remove null/undefined, and join them
        return filteredTractList
            .map(t => t.shortLegalDescription?.trim()) // safely access & trim // remove falsy
            .join('\n\n'); // join with 2 line breaks
    };

    public static getGlobalId = (tractDetail: ContractGenerationTractDetail | LeaseGenerationTractDetail, parentTractType: string) => {
        let global = '';
        let horizonString = tractDetail.tractNumber + 'm-' + tractDetail.horizonNumber;
        let surfaceString = tractDetail.surfaceTractNumber + 's';
        let section = tractDetail.sectionNumber + '.';

        global = section;
        if (parentTractType === 'Mineral Tract') {
            global += horizonString;
            if (tractDetail.type === 'Surface') {
                global += '.' + surfaceString;
            }
        } else if (parentTractType === 'Surface Tract') {
            global += surfaceString;
            if (tractDetail.type === 'Mineral') {
                global += '.' + horizonString;
            }
        }

        return global;
    };

    public static navigateToTract = (tract: ContractGenerationTractDetail | LeaseGenerationTractDetail, tractTypeId: number, clientNumber: number, projectNumber: number, landSystem: LandSystem) => {
        switch (tractTypeId) {
            case 1:
                return `/clients/${clientNumber}/projects/${projectNumber}/sections/${tract.sectionNumber}/tracts/${tract.tractNumber
                    }/horizons/${tract.horizonNumber > 0 ? tract.horizonNumber : 1}`;
            case 2:
                return `/clients/${clientNumber}/projects/${projectNumber}/sections/${tract.sectionNumber}/surface-tracts/${tract.surfaceTractNumber}`;
            case null:
            case 0:
                return `/clients/${clientNumber}/projects/${projectNumber}/sections/${tract.sectionNumber}/tracts/${tract.tractNumber
                    }/horizons/${tract.horizonNumber > 0 ? tract.horizonNumber : 1}`;
            default:
                return `/clients/${clientNumber}/projects/${projectNumber}/sections/${tract.sectionNumber}`;
        }
    };

    // parse the boolean value from RHFToggle
    public static parseBool = (value: string) => {
        if (value === 'true') {
            return true;
        } else if (value === 'false') {
            return false;
        }
        return null;
    };

    public static getOptions = (measurementTypes: IndexReferenceType[], type: string, item: string = '') => {
        if (measurementTypes?.length > 0) {
            return measurementTypes
                .filter((mt) => mt.description === type)
                .map((option) => {
                    if (type === 'Fee' && option.name === 'Per Item') {
                        return { value: option.id, label: `Per ${item}` };
                    }
                    return { value: option.id, label: option.name };
                });
        }
        return [];
    };

    public static convertToPlainText = (rtf: string) => {
        rtf = rtf.replace(/&nbsp;/g, ' ');
        rtf = rtf.replace(/<\/p>/g, `\n`);
        rtf = rtf.replace(/<\/[a-zA-z]+>|<[a-zA-z]+>|\&nbsp;/g, '');
        return rtf.trim();
    };

    public static tagsToString = (tagItems: Tag[]) => {
        let tempString = '';
        tagItems.forEach((tag) => {
            tempString = tempString.concat(tag.name);
            if (tag !== tagItems[tagItems.length - 1]) {
                tempString = tempString.concat(', ');
            }
        });
        return (
            tempString.concat(' ')
        );
    }

    public static navToLeasehold = (ownershipId: number, contractId: number, contractholdId: number, contractType: string) => {
        let navPath = '';

        switch (contractType) {
            case 'Lease':
            case 'Oil and Gas Lease':
                navPath = `/ownership/${ownershipId}/leases/${contractId}/leaseholds/${contractholdId}`;
                break;
            case 'Surface Waiver':
                navPath = `/ownership/${ownershipId}/surface-waivers/${contractId}/surface-waiver-holds/${contractholdId}`;
                break;
            case 'Solar Lease':
                navPath = `/ownership/${ownershipId}/solar-leases/${contractId}/solar-lease-holds/${contractholdId}`;
                break;
            case 'Battery Storage':
                navPath = `/ownership/${ownershipId}/battery-storage/${contractId}/battery-storage-holds/${contractholdId}`;
                break;
            case 'Brine Lease':
                navPath = `/ownership/${ownershipId}/brine-leases/${contractId}/brine-lease-holds/${contractholdId}`;
                break;
            case 'Right Of Way':
                navPath = `/ownership/${ownershipId}/right-of-ways/${contractId}/right-of-way-holds/${contractholdId}`;
                break;
            case 'Carbon Capture System':
                navPath = `/ownership/${ownershipId}/carbon-captures/${contractId}/carbon-capture-holds/${contractholdId}`;
                break;
            default:
                break;
        }

        return navPath;
    };

    public static navToAcquisition = (ownerId: number, contractId: number, contractType: string) => {
        let navPath = '';

        switch (contractType) {
            case 'Lease':
            case 'Oil and Gas Lease':
                navPath = `/acquisitions/lease-generation/ownerId/${ownerId}/leases/${contractId}`;
                break;
            case 'Surface Waiver':
                navPath = `/acquisitions/lease-generation/ownerId/${ownerId}/surface-waivers/${contractId}`;
                break;
            case 'Solar Lease':
                navPath = `/acquisitions/lease-generation/ownerId/${ownerId}/solar-leases/${contractId}`;
                break;
            case 'Battery Storage':
                navPath = `/acquisitions/lease-generation/ownerId/${ownerId}/battery-storage/${contractId}`;
                break;
            case 'Brine Lease':
                navPath = `/acquisitions/lease-generation/ownerId/${ownerId}/brine-leases/${contractId}`;
                break;
            case 'Right Of Way':
                navPath = `/acquisitions/lease-generation/ownerId/${ownerId}/right-of-ways/${contractId}`;
                break;
            case 'Carbon Capture System':
                navPath = `/acquisitions/lease-generation/ownerId/${ownerId}/carbon-captures/${contractId}`;
                break;
            default:
                break;
        }

        return navPath;
    };

    public static navOwnersToLeasehold = (landSystem: LandSystem, parentTract: string, fieldNo: number, tractNo: number, horizonNo = 0) => {
        let fieldName = '';
        fieldName = landSystem === LandSystem.Eastern ? 'maps' : 'sections';
        // Leaving this here in case the landSystem check gets more complex.
        // switch (landSystem) {
        //     case LandSystem.Jeffersonian:
        //     case LandSystem.WestTexas:
        //     case LandSystem.EastTexas:
        //     case LandSystem.RightOfWay:
        //         fieldName = 'sections';
        //         break;
        //     case LandSystem.Eastern:
        //         fieldName = 'maps';
        //         break;
        //     default:
        //         break;
        // }

        let tractName = '';
        if (parentTract === 'Mineral Tract') {
            tractName = `tracts/${tractNo}/horizons/${horizonNo}`;
        } else if (parentTract === 'Surface Tract') {
            tractName = `surface-tracts/${tractNo}`;
        }

        const navPath = `/${fieldName}/${fieldNo}/${tractName}`;

        return navPath;
    };

    // Private formatting methods for tract list.
    private static tractListData = (tracts: Array<ContractGenerationTractDetail>) => {
        if (tracts?.length > 0) {
            let globalIds: string[] = tracts?.map((t) => {
                return `${t.sectionNumber}.${t.tractNumber}`;
            });
            let mineralTracts = tracts.filter(t => t.horizonNumber > 0);

            let correctTracts: Array<ContractGenerationTractDetail> = AgreementUtil.finalTractList(mineralTracts, globalIds);

            return correctTracts;
        }
        return [];
    };

    private static finalTractList = (tracts: Array<ContractGenerationTractDetail>, ids: Array<string>) => {
        let finalTracts: Array<ContractGenerationTractDetail> = [];
        let singles: Array<ContractGenerationTractDetail> = [];
        let tractsToBeRender: Array<ContractGenerationTractDetail> = [];

        for (let i = 0; i < ids.length; i++) {
            let filteredTracts: Array<ContractGenerationTractDetail> = tracts.filter((t) => `${t.sectionNumber}.${t.tractNumber}` === ids[i]);
            let itemExist: ContractGenerationTractDetail = finalTracts?.find(
                (tt: ContractGenerationTractDetail) =>
                    `${tt?.sectionNumber}.${tt?.tractNumber}` === `${tracts[i]?.sectionNumber}.${tracts[i]?.tractNumber}`
            );

            if (filteredTracts.length > 1 && !itemExist) {
                finalTracts = finalTracts.concat(AgreementUtil.tractCorrection(filteredTracts));
            }

            if (filteredTracts.length === 1) {
                singles.push(...filteredTracts);
            }
        }

        if (singles.length >= 1) {
            tractsToBeRender.push(...finalTracts);
            tractsToBeRender.push(...singles);
        } else {
            tractsToBeRender = finalTracts;
        }

        return tractsToBeRender;
    };

    // Function to remove duplicates based on global id
    private static tractCorrection = (duplicates: Array<ContractGenerationTractDetail>) => {
        let decimalInterestValues: Array<number> = duplicates.map((dt) => {
            return dt.decimalInterest;
        });

        let tractsToKeep: Array<ContractGenerationTractDetail> = [];

        let highestDI = Math.max(...decimalInterestValues);
        let lowestDI = Math.min(...decimalInterestValues);

        if (highestDI === lowestDI) {
            let tracts: ContractGenerationTractDetail = duplicates[0];
            tractsToKeep.push(tracts);
        } else {
            let tracts: ContractGenerationTractDetail = duplicates.find((d) => parseFloat(d.decimalInterest + '') === highestDI);
            tractsToKeep.push(tracts);
        }

        return tractsToKeep;
    };

    private static regenerateShortLegalDescription = (tract: ContractGenerationTractDetail, owner: Ownership, ownerInfo: IOwner): string => {
        let grossAcres = tract.grossAcres;
        let decimalInterest = owner.decimalInterest;
        let ownerAcres = parseFloat(MathUtil.cleanNumber(grossAcres * decimalInterest));

        // grabbing first half of short legal description
        let currentShortLegalDescription = tract.shortLegalDescription;
        let searchPhrase = 'including lands acquired from';
        let breakPoint = currentShortLegalDescription.search(searchPhrase);
        let phraseCharCount = searchPhrase.length;

        let firstHalfSLD = currentShortLegalDescription.substring(0, breakPoint + phraseCharCount);

        // reconstructing second half with vesting deed info
        let secondHalfSLD =
            ' ' + ownerInfo.name +
            ', by virtue of ' + convertInstrumentTypesToSelectList()[Number(owner.vestingDeedInstrumentType) - 1].name +
            ' dated ' + owner.vestingDeedDate +
            ', recorded in ' + owner.vestingDeedReference +
            ', described for the purposes of this agreement as containing a total of ' + ownerAcres +
            ' Leasehold acres, whether actually more or less, and including contiguous lands owned by Lessor.';

        return firstHalfSLD + secondHalfSLD;
    };
}



// WEBPACK FOOTER //
// ./src/util/AgreementUtil.ts